import { type Component, type JSX } from 'solid-js'

export interface DialogActionsProps {
  readonly children: JSX.Element
}

const DialogActions: Component<DialogActionsProps> = (props) => {
  return (
    <div class="pt-4 flex justify-end gap-6 rounded-b-md border-t boder-t-gray-200">
      { props.children }
    </div>
  )
}

export default DialogActions
